import { render } from "./InstitutionList.vue?vue&type=template&id=7b4c13b9&scoped=true"
import script from "./InstitutionList.vue?vue&type=script&lang=js"
export * from "./InstitutionList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4c13b9"]])

export default __exports__